<template>
    <section>
      <div class="sp-title">{{pageTitle}}未出账发票</div>
      <el-form :inline="true" :model="queryForm" class="query-form demo-form-inline">
        <el-form-item label="供应商名称" style="text-align: left" >
          <el-input v-model="queryForm.name" placeholder="供应商名称"  clearable></el-input>
        </el-form-item>
        <el-form-item label="开票公司" style="text-align: left" >
          <el-input v-model="queryForm.fullName" placeholder="开票公司"  clearable></el-input>
        </el-form-item>
        <el-form-item><el-button @click="getDetailData" type="primary" >查询</el-button></el-form-item>
        <el-form-item><el-button @click="addNoCostBill" type="primary" >新增未出账发票</el-button></el-form-item>
      </el-form>
      <el-table
        class="el-table-info"
        :data="tabledata"
        stripe
        style="width: 100%;margin-top: 30px"
        :show-overflow-tooltip="true"
        border
      >
        <el-table-column
          :formatter="publicFmt"
          prop="supplierName"
          label="供应商名称"
        >
        </el-table-column>
        <el-table-column
          :formatter="publicFmt"
          prop="sysSupplierFullName"
          label="开票公司"
        >
        </el-table-column>
        <el-table-column
          prop="ticketPayment"
          :formatter="NumFmt"
          label="进票金额"
        >
        </el-table-column>
        <el-table-column
          :formatter="publicFmt"
          prop="invoiceNumber"
          label="发票号"
        >
        </el-table-column>
        <el-table-column
          :formatter="contractCompanyFmt  "
          prop="invoiceCompany"
          label="合同公司"
        >
        </el-table-column>
        <el-table-column
          prop="createDate"
          :formatter="(row, column, cellValue, index) => { return myFmtDateTime(cellValue,'MM/DD')}"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          width="300"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.isFinish == 1">
              <el-button @click="showDetail(scope.row)" type="text" size="small">费用选择</el-button>
              <el-button @click="deleteDataDetail(scope.row)" type="text" size="small">删除</el-button>
            </div>
            <div v-if="scope.row.isFinish == 0">
              <el-button class="change-color" type="text" size="small" style="cursor:not-allowed;">正在审批中</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>


      <work-flow-component ref="processDrawer1" @onCallback="getSpIdTicket" componentsWidth="65%">
        <div slot="beforeFormSlot" style="position: relative;">
          <TicketApprove ref="ticketApprove" :applyObj="applyObj"></TicketApprove>
        </div>
      </work-flow-component>


      <el-dialog
        class="xuanxiang"
        title="发票费用选择"
        :visible.sync="showApplyTicket"
        width="60%"
        :before-close="ApplyhandleClose"
        :close-on-click-modal=false
      >
        <el-table
          :data="tabledata111"
          class="el-table-info"
          @cell-click="showMsg1"
          @row-click="checkRow1"
          :summary-method="getSummaries"
          :cell-class-name="setColumnClassName1"
          show-summary
          stripe
          style="margin-left: 5%;width: 90%;"
          v-loading="tableLoading2"
        >
          <el-table-column
            fixed
            width="50">
            <template slot-scope="scope"><img :class="!scope.row.checked?'showpic':''" style="width: 14px;vertical-align: middle;" src="../assets/img/yixuanze.png"/></template>
          </el-table-column>
          <el-table-column
            :formatter="publicFmt"
            prop="shipName"
            label="船舶名称"
            width="80">
          </el-table-column>
          <el-table-column
            :formatter="costTypeFmt"
            prop="costTypeName"
            label="费用类型"
            width="80">
          </el-table-column>
          <el-table-column
            :formatter="contractCompanyFmt"
            prop="contractCompanyName"
            label="收票公司"
            width="100">
          </el-table-column>
          <el-table-column
            :formatter="costProjecttax"
            prop="billTax"
            label="税率"
            width="90">
          </el-table-column>
          <el-table-column
            :formatter="NumFmt2"
            prop="settleTonnage"
            label="吨位"
            width="90">
          </el-table-column>
          <el-table-column
            :formatter="NumFmt"
            prop="priceWithTax"
            :label="labelName"
            width="90">
          </el-table-column>
          <el-table-column
            :formatter="NumFmt"
            prop="arrearsAmount"
            label="欠票金额"
            width="100"
          >
          </el-table-column>
          <el-table-column
            :formatter="NumFmt"
            prop="moneyInApply"
            label="审批中"
            width="120"
          >
          </el-table-column>
          <el-table-column
            :formatter="NumFmt"
            prop="leftOver"
            label="总剩余"
            width="120"
          >
          </el-table-column>
          <el-table-column
            :formatter="NumFmt"
            prop="currentAmount"
            label="本次进票金额"
          >
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer" >
                <el-button type="primary" @click="temporarySave">暂存</el-button>
                <el-button type="primary" @click="applyVerifyTicket">提交</el-button>
            </span>
      </el-dialog>

      <el-dialog
        class="xuanxiang"
        title="新增未出账发票"
        :visible.sync="showNoCostBill"
        width="60%"
        :before-close="showNoCostBillhandleClose"
        :close-on-click-modal=false
      >
        <el-form
          class="myform query-form"
          label-position="left"
          label-width="80px"
          :model="noCostbill"
        >
          <div style="display: flex;padding: 20px 30px;">
            <div class="sp_add_left">
              <el-form-item label="供应商" label-width="90px">
                <PanelSelection @setVal="setSupplier" :allData="supplierList"
                                modeName="公司名称" dataKey="common_supplier"   keyStr="id" valStr="simpleName"
                                ref="supplier"
                ></PanelSelection>
              </el-form-item>
              <el-form-item label="发票金额" label-width="90px">
                <el-input v-model="noCostbill.ticketPayment" placeholder="请输入发票金额" clearable></el-input>
              </el-form-item>
              <el-form-item label="合同公司" label-width="90px">
                <el-tag style="margin-right: 10px;margin-bottom: 10px;cursor: pointer;" :type="noCostbill.invoiceCompany==item.code?'success':'info'"
                        v-for="(item,index) in  contractCompanyList" :key="index" @click="noCostbillInvoice(item.code)"
                >{{item.value}}</el-tag>
              </el-form-item>
            </div>

            <div class="sp_add_right">
              <el-form-item label="开票公司" label-width="90px">
                <PanelSimpleSelection @setVal="setSettleSupplier" :allData="settleCompanyList"
                                      modeName="公司名称" keyStr="id" valStr="name"
                                      ref="settleSupplier"
                ></PanelSimpleSelection>
              </el-form-item>
              <el-form-item label="发票号" label-width="90px">
                <el-input v-model="noCostbill.invoiceNumber" placeholder="请输入发票号" clearable></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer" >
                <el-button type="primary" @click="saveNoCostBill">提交</el-button>
          </span>
      </el-dialog>

    </section>
</template>

<script>

import {getDictionaryList} from "../api/sysdictionary";
import {ERR_OK} from "../jslib/config";
import {fmtDictionary} from "../jslib/util";
import {
  checkApplyCost,
  delNoCostBillList,
  getNoCostBillList,
  saveNoCostBill, temporarySaveTicket, temporarySaveTicketNoCost,
} from "../api/PaymentApply";
import dayjs from "dayjs";
import TicketBatchApprove from "../components/approval/TicketBatchApprove";
import WorkFlowComponent from "../components/workflow/index";
import {getAllSysSupplier, getSettleCompanyList} from "../api/syssupplier";
import PanelSelection from "../components/common/panelSelection";
import PanelSimpleSelection from "../components/common/panelSimpleSelection";
import TicketApprove from "../components/approval/TicketApprove";
import {getInterTicketListById} from "../api/costAggregation";

export default {
    data() {
        return {
          tabledata:[],
          dictionaryLists:[],
          contractCompanyList:[],
          tabledata111:[],
          newdictionaryLists:[],
          isGoods:false,
          labelName:null,
          showApplyTicket:false,
          pageTitle:null,
          queryForm:{},
          showNoCostBill:false,
          noCostbill:{
            sysSupplierId:null,
            supplierName:null,
            sysSupplierFullName:null,
            invoiceCompany:null,
            ticketPayment:null,
            invoiceNumber:null,
            routeName:null,
          },
          supplierList:[],
          settleCompanyList:[],
          applyObj:{},
          tableLoading2:true,
          applicationForm:{},
          applyData:[],
        };
    },
    created() {
      this.initData()
      getAllSysSupplier().then(res=>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          this.supplierList = res.list
        }
      })
      getDictionaryList("cost_type,contract_company,bill_tax,items_occurred,other_expenditure").then(res=>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          this.dictionaryLists = res.map
          this.contractCompanyList = []
          if(this.isGoods){
            this.newdictionaryLists = this.dictionaryLists["cost_type"]
          } else {
            if(this.$route.query.routeName == "applyinterticketothercost"){
              this.newdictionaryLists = this.dictionaryLists["other_expenditure"]
            } else {
              this.newdictionaryLists = this.dictionaryLists["items_occurred"]
            }
          }
          for(var i=0;i<this.dictionaryLists["contract_company"].length;i++){
            if(this.dictionaryLists["contract_company"][i].code == 10 || this.dictionaryLists["contract_company"][i].code == 20){
              this.contractCompanyList.push(this.dictionaryLists["contract_company"][i])
            }
          }
        }
      })
    },
    mounted() {
      this.getDetailData()
    },
    methods: {
      temporarySave(){
        this.applyData = []
        var applyDataIds = []
        var totalPrice = 0
        for(var i=0;i<this.tabledata111.length;i++){
          if(this.tabledata111[i].checked){
            this.applyData.push(this.tabledata111[i])
            applyDataIds.push(this.tabledata111[i].id)
            totalPrice += this.tabledata111[i].currentAmount
          }
        }
        if(this.applicationForm.ticketPayment == totalPrice){
            this.applyObj = {
              application:this.applicationForm,
              applylist:this.applyData,
            }
            var datastr = JSON.stringify(this.applyObj)
            var datajson =  encodeURIComponent(datastr)
            var querydata = {
              datajson:datajson
            }
          temporarySaveTicketNoCost(querydata).then(res =>{
              if (res!=undefined&&res.resultCode === ERR_OK) {
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: '暂存成功'
                });
              }
            }).finally(this.getDetailData())
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: '进票金额与发票金额不一致'
          });
        }
      },
      applyVerifyTicket(){
        this.applyData = []
        var applyDataIds = []
        var totalPrice = 0
        for(var i=0;i<this.tabledata111.length;i++){
          if(this.tabledata111[i].checked){
            this.applyData.push(this.tabledata111[i])
            applyDataIds.push(this.tabledata111[i].id)
            totalPrice += this.tabledata111[i].currentAmount
          }
        }
        if(this.applicationForm.ticketPayment == totalPrice){
            this.applyObj = {
              application:this.applicationForm,
              applylist:this.applyData
            }
            this.$refs.processDrawer1.title = this.pageTitle+'进票审批'
            this.$refs.processDrawer1.drawer = true
            this.$nextTick(function () {
              this.$refs.ticketApprove.getData()
            })
            this.$refs.processDrawer1.processCode = "ticketApprove"
            this.$refs.processDrawer1.globalParams = {}
            this.$refs.processDrawer1.globalParams.params2 = applyDataIds.toString()
            this.$refs.processDrawer1.briefContent = "发票号："+this.applicationForm.invoiceNumber+",进票总金额为："+ (parseFloat(Math.abs(this.applicationForm.ticketPayment).toFixed(2))+parseFloat(Math.abs(this.applicationForm.additionalPrice).toFixed(2)))
            this.$refs.processDrawer1.doInit()
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: '进票金额与发票金额不一致'
          });
        }
      },
      checkRow1(row, column, event){
        console.info(row)
        if(column != undefined) {
          if (column.label != "本次进票金额") {
            if (Number(row.contractCompany) == Number(this.applicationForm.invoiceCompany)) {
              if(row.leftOver != 0){
                if (row.checked == false) {
                  row.checked = true;
                  if (!!row.arrearsAmount) {
                    if(row.arrearsAmount < this.applicationForm.ticketPayment){
                      row.currentAmount = row.arrearsAmount;
                    } else {
                      row.currentAmount = this.applicationForm.ticketPayment
                    }
                  } else {
                    if(row.leftOver < this.applicationForm.ticketPayment){
                      row.currentAmount = row.leftOver;
                    } else {
                      row.currentAmount = this.applicationForm.ticketPayment
                    }
                  }
                  // row.charge = row.amountDue - row.currentAmount;
                } else {
                  row.checked = false;
                  row.currentAmount = 0;
                  // row.charge = row.amountDue - row.currentAmount;
                }
              } else {
                this.$message({
                  showClose: true,
                  type: 'error',
                  message: '此费用无法继续发起进票申请'
                });
              }
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: '该航次的合同公司与选择的收票公司不一致，无法选择'
              });
            }
          }
        }
      },
      showMsg1(row, column, cell, event){
        if(column.label == "本次进票金额") {
          if (Number(row.contractCompany) == Number(this.applicationForm.invoiceCompany)) {
            this.$prompt('请输入本次进票金额', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputValue:this.NumFmt2(null,null,row.currentAmount,null)
            }).then(({value}) => {
              if (isNaN(value)) {
                this.$message({
                  showClose: true,
                  type: 'error',
                  message: '只允许输入数字'
                });
              } else {
                row.currentAmount = Number(value)
                // var p =  Number(row.amountDue)-Number(row.currentAmount)
                // row.charge = p>0?p:0
                if (value > 0) {
                  row.checked = true
                } else {
                  row.checked = false
                }
              }
            }).catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: '取消输入'
              });
            });
          }else {
            this.$message({
              showClose: true,
              type: 'error',
              message: '该航次的合同公司与选择的收票公司不一致，无法选择'
            });
          }
        }
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总计';
            return;
          }
          if(index < 5 || column.label == "单价"){
            sums[index] = '--';
            return;
          }
          const values = data.map(item =>Math.abs(Number(item[column.property])) );
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = this.NumFmt(null,null,sums[index],null);
            // sums[index] += ' 元';
          } else {
            sums[index] = '--';
          }
        });
        return sums;
      },
      setColumnClassName1({row, column, rowIndex, columnIndex}){
        if(columnIndex == 10){
          return 'colum-class'
        }
        return '';
      },
      getSpIdTicket(id){
        this.showApplyTicket = false
        console.log('审批成功，实例ID：' + id);
        var data = {
          application:this.applicationForm,
          applylist:this.applyData,
          processId:id,
        }
        var datastr = JSON.stringify(data)
        var datajson =  encodeURIComponent(datastr)
        var querydata = {
          datajson:datajson
        }
        checkApplyCost(querydata).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
          }
        }).finally(() =>{
          this.getDetailData()
        })
      },
      saveNoCostBill(){
        this.noCostbill.routeName = this.$route.query.routeName
        saveNoCostBill(this.noCostbill).then(res=>{
          if(res != undefined && res.resultCode === ERR_OK){
            this.$message({
              showClose: true,
              type: 'success',
              message: '新增成功'
            });
            this.showNoCostBillhandleClose()
            this.getDetailData()
          }
        })
      },
      setSettleSupplier(obj){
        this.noCostbill.sysSupplierFullName = obj.name
      },
      setSupplier(obj){
        this.getSettleCompanyList(obj.id)
        this.$refs.settleSupplier.clean()
        this.noCostbill.sysSupplierId = obj.id
        this.noCostbill.supplierName = obj.simpleName
      },
      getSettleCompanyList(id){
        getSettleCompanyList(id).then(res=>{
          if (res != undefined && res.resultCode === ERR_OK) {
            this.settleCompanyList = res.list
          }
        })
      },
      addNoCostBill(){
        this.showNoCostBill = true
      },
      noCostbillInvoice(id){
        this.noCostbill.invoiceCompany = id
      },
      showNoCostBillhandleClose(){
        this.showNoCostBill = false
      },
      ApplyhandleClose(){
        this.showApplyTicket = false
      },
      initData(){
        if(this.$route.query.routeName == "applyinterticketshippay"){
          this.isGoods = false
          this.labelName = "单价"
          this.pageTitle = "船舶运费"
        } else if (this.$route.query.routeName == "applyinterticketgoods") {
          this.isGoods = true
          this.labelName = "单价"
          this.pageTitle = "货物费用"
        } else if(this.$route.query.routeName == "applyinterticketshipcost") {
          this.isGoods = false
          this.labelName = "金额"
          this.pageTitle = "船上费用"
        } else if(this.$route.query.routeName == "applyinterticketothercost"){
          this.isGoods = false
          this.labelName = "金额"
          this.pageTitle = "其他费用"
        }
      },
      getDetailData(){
        var query = {
          routeName:this.$route.query.routeName,
          supplierName:this.queryForm.name,
          fullName:this.queryForm.fullName
        }
        getNoCostBillList(query).then(res=>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.tabledata = res.list
          }
        })
      },
      showDetail(obj){
        this.showApplyTicket = true
        this.applyData =[]
        this.getTableData111(obj)
        this.applicationForm = obj
      },
      getTableData111(obj){
        this.tableLoading2 = true
        this.tabledata111 =[]
        var querydata = {
          cusSupId:obj.sysSupplierId,
          invoiceCompany:obj.invoiceCompany,
          routeName:obj.routeName,
          status:1
        }
        getInterTicketListById(querydata).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            for(var i=0;i<res.list.length;i++){
              res.list[i].checked = false
            }
            this.tabledata111 = res.list
          }
        }).finally(()=>{
          this.tableLoading2 = false
        })
      },
      deleteDataDetail(obj){
        this.$confirm('此操作将删除该发票记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var query = {
            id:obj.id
          }
          delNoCostBillList(query).then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getDetailData()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      publicFmt(row,column,cellValue,index){
        var v = '--'
        if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
          v = cellValue
        }
        return v
      },
      NumFmt(row,column,cellValue,index){
        var v = 0
        if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
          v = parseFloat(Math.abs(cellValue).toFixed(2))
        }
        return v
      },
      NumFmt2(row,column,cellValue,index){
        var v = 0
        if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
          v = parseFloat(Math.abs(cellValue).toFixed(2))
        }
        return v
      },
      contractCompanyFmt(row,column,cellValue,index){
        return fmtDictionary(cellValue,this.contractCompanyList);
      },
      myFmtDateTime(cellValue,fmtstr){
        if(cellValue==undefined||cellValue==null||cellValue==''){
          return '--'
        }
        return dayjs(cellValue).format(fmtstr)
      },
      costTypeFmt(row,column,cellValue,index){
        return fmtDictionary(cellValue,this.newdictionaryLists);
      },
      costProjecttax(row, column, cellValue, index) {
        return fmtDictionary(cellValue, this.dictionaryLists['bill_tax']);
      },
    },
    computed: {},
    components: {PanelSelection,PanelSimpleSelection,TicketBatchApprove,WorkFlowComponent,TicketApprove}
}
</script>

<style scoped>
  .el-table-info >>> .cell{
    text-align: center;
  }
  .el-table-info >>> th {
    background: #EDF5FF;
  }
  .query-form{
    text-align: left;
    padding-top: 10px;
  }

  .sp_add_left{
    width: 45%;
    margin-right: 5%;
  }
  .sp_add_right{
    width: 45%;
  }
  .mytable td  {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .mytable td .cell {
    padding-left: 0.1rem;
    padding-right: 0.1rem;
  }
  .el-table-info >>> .warning-cell{
    color: red;
  }
  .el-table-info >>> .success-cell{
    color: #6DD400;
  }
  .myStep >>>.el-step__main{
    margin-top: 10px;
  }
  .myform >>> .el-form-item{
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .change-color{
    color: #F56C6C;
  }
  .change-gray{
    color: #909399;
  }
  .xuanxiang >>> .el-dialog__body{
    padding: 0px !important;
  }

  .el-table-info >>> .colum-class {
    color: #2cb7fd;
  }
  .el-table-info >>> .colum-class-false {
    color: #C0C4CC;
  }
  .showpic{
    display: none;
  }
  .input-box1{
    width: 100%;
    display:flex;
  }
</style>
